/* Phone Mask */
function phoneMask (phone) {
  return phone.replace(/\D/g, '')
    .replace(/^(\d)/, '($1')
    .replace(/^(\(\d{2})(\d)/, '$1) $2')
    .replace(/(\d{4})(\d{1,5})/, '$1-$2')
    .replace(/(-\d{5})\d+?$/, '$1')
}

/* Phone Mask */
function handleInput (e) {
  e.target.value = phoneMask(e.target.value)
}

function handlingSMSFooterError() {
  console.log(`handling SMS field error...`)
}

function handlingSMSFooterSuccess() {
  const smsInput = document.getElementById('listrak-sms-form-input')
  const smsSubmit = document.getElementById('listrak-sms-form-submit')
  const smsSuccess = document.querySelector('.listrak-sms-form-submit-success')
  smsInput && smsInput.classList.add('hidden')
  smsSubmit && smsSubmit.classList.add('hidden')
  smsSuccess && smsSuccess.classList.add('active')
}

/* Submit Form */
function validateSubmitSMSField(event) {
  event.preventDefault()
  const listrakFooterSMSData = _ltk?.Signup?.GetSavedSubscriberData()?.lists?.footerSMS
  const phoneNumber = listrakFooterSMSData && listrakFooterSMSData.ltkEmail
  if (phoneNumber) {
    handlingSMSFooterSuccess()
  } else {
    handlingSMSFooterError()
  }

}

const phoneInput = document.querySelector('#listrak-sms-form-input');
const footerContainer = document.getElementById('listrak-footer-container');
const submitButton = document.querySelector('.listrak-sms-form-submit');

if (phoneInput) {
  phoneInput.addEventListener('input', handleInputPhone);
  phoneInput.addEventListener('focus', handleFocusPhone);
}

function handleInputPhone(event) {
   let inputValue = event.target.value.trim().replace(/\D/g, '');

    if (!inputValue.startsWith('1')) {
        inputValue = '1' + inputValue;
    }

    const formattedValue = inputValue.slice(0, 1) + inputValue.slice(1, 4) + inputValue.slice(4, 7) + inputValue.slice(7, 11);

    event.target.value = formattedValue;

    const isValidUSPhoneNumber = /^\+1\d{10}$/.test(formattedValue);
    if (!isValidUSPhoneNumber || !/^\+?[0-9]*$/.test(event.target.value)) {
        event.target.classList.add('error');
    } else {
        event.target.classList.remove('error');
        if (footerContainer) footerContainer.classList.remove('sms-error');
    }
}

function handleFocusPhone(event) {
    let inputValue = event.target.value.trim().replace(/\D/g, '');

    if (!inputValue.startsWith('1')) {
        event.target.value = '1' + inputValue;
    }
}

function phoneValidation(event) {
    event.preventDefault();

    if (!phoneInput) return false;

    let inputValue = phoneInput.value.trim().replace(/\D/g, '');
    const isValidUSPhoneNumber = /^\d{11}$/.test(inputValue);

    const areaCode = inputValue.substring(1, 4);

    const regexAreaCode = /^[2-9][0-9]{2}$/;
    const isValidAreaCode = regexAreaCode.test(areaCode);

    if (!isValidUSPhoneNumber || !isValidAreaCode) {
        phoneInput.classList.add('error');
        if (footerContainer) footerContainer.classList.add('sms-error');
        return false;
    } else {
        phoneInput.classList.remove('error');
        if (footerContainer) footerContainer.classList.remove('sms-error');
        return true;
    }
}

document.addEventListener('DOMContentLoaded', () => {
  /* Form submit */
  const submitSMS = document.getElementById('listrak-sms-form-submit')
  submitSMS && submitSMS.addEventListener('click', function(event) {
    
    if(phoneValidation(event)){
       validateSubmitSMSField(event)
    }
   
  })

})

/* ---------------------------------------------------------------------------
 * Footer email signup — subscribes to LISTRAK.
 *
 * The list is the `listrak_email_list` theme setting, default "Footer", which
 * is the email list already configured on the account. Read the real ones with
 * _ltk.Signup.GetSavedSubscriberData() — currently
 * {Account: email, HueQuiz, Footer: email, footerSMS: sms}. The SMS box beside
 * this one uses footerSMS the same way.
 *
 * API verified against the live Listrak bundle: Subscriber exposes Email /
 * List / SourceUID / Profile as PROPERTIES plus a Submit() method. There is no
 * SetEmail(), which is what the name would lead you to write. Submit() sends a
 * 1x1 image beacon — fire and forget, nothing to await.
 *
 * There is deliberately NO <form> element behind this control, and no submit
 * handler. Three separate reload bugs came out of having one:
 *   1. {% form 'customer' %} posts natively and reloads to the TOP of the page,
 *      while the confirmation renders down here in the footer — so a signup
 *      that HAD worked looked like a dead reload.
 *   2. Re-issuing that post over fetch is impossible: Shopify answers a fetch
 *      POST to /contact with 403 (a real navigation is fine, an XHR is not).
 *      That version captured nothing and, worse, its .catch fell back to
 *      form.submit() — recreating the reload it existed to remove.
 *   3. Once the JS cleared the input on success, any native post that still got
 *      through arrived empty and Shopify answered "Email can't be blank".
 * With no form there is no submit event, no default action, and nothing that
 * can navigate the page. Subscribing is a click handler and a Listrak beacon.
 * NOTE this also means no no-JS fallback and no Shopify customer record — the
 * subscriber goes to Listrak only, which is the requirement.
 * ------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  var widget = document.getElementById('FooterEmailSignup');
  if (!widget) return;

  var input = widget.querySelector('#footer-email-input');
  var button = widget.querySelector('.footer-block__cta-submit');
  var msgEl = widget.querySelector('.footer-block__cta-message--js');

  function showMessage(text, isError) {
    if (!msgEl) return;
    msgEl.textContent = text;
    msgEl.classList.toggle('footer-block__cta-message--error', !!isError);
    msgEl.classList.toggle('footer-block__cta-message--success', !isError);
    msgEl.hidden = false;
  }

  // Everything this widget does with Listrak is logged under [footer-signup]
  // so a failed signup can be diagnosed from the console instead of guessed at.
  function log() {
    try {
      console.log.apply(console, ['[footer-signup]'].concat([].slice.call(arguments)));
    } catch (e) { /* console unavailable */ }
  }

  // Listrak's own record of the subscribe. Submit() fires a 1x1 image beacon
  // and returns nothing, so there is no response object to inspect — this is
  // the closest thing to one. The list flips to ltkSaved:true once accepted.
  function listrakRecord(list) {
    try {
      var data = _ltk.Signup.GetSavedSubscriberData() || {};
      return (data.lists || {})[list];
    } catch (e) {
      return 'unreadable: ' + e;
    }
  }

  function tryListrak(value) {
    if (typeof _ltk === 'undefined' || !_ltk || !_ltk.Subscriber) return false;
    var list = widget.getAttribute('data-listrak-list') || 'Footer';
    try {
      log('subscribing', value, 'to list', list);
      log('record before:', listrakRecord(list));
      _ltk.Subscriber.Email = value;
      _ltk.Subscriber.List = list;
      _ltk.Subscriber.Submit();
      log('Submit() returned; record now:', listrakRecord(list));
      // The beacon is async, so re-read shortly after — this is the one that
      // usually shows ltkSaved:true.
      setTimeout(function () {
        log('record after 1.5s:', listrakRecord(list));
      }, 1500);
      return true;
    } catch (e) {
      log('Submit() THREW:', e);
      return false;
    }
  }

  // Listrak loads asynchronously, so on a fast
  // click it may not exist yet. Clicking IS an interaction, which triggers that
  // load, so poll briefly rather than dropping the subscriber — then report
  // back so the UI can tell the truth either way.
  function subscribe(value, done) {
    var attempts = 0;
    (function attempt() {
      if (tryListrak(value)) return done(true);
      if (++attempts >= 25) { log('gave up: _ltk.Subscriber never appeared after ~5s'); return done(false); }
      setTimeout(attempt, 200);
    })();
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  function handleSubscribe() {
    var value = input && input.value ? input.value.trim() : '';
    if (!isValidEmail(value)) {
      showMessage('Please enter a valid email address.', true);
      if (input) input.focus();
      return;
    }
    log('submit clicked with', value);
    if (button) button.disabled = true;
    subscribe(value, function (ok) {
      if (button) button.disabled = false;
      if (ok) {
        showMessage('Thank you for subscribing.', false);
        input.value = '';
      } else {
        log('FAILED — Listrak never became available');
        showMessage('Sorry, something went wrong. Please try again.', true);
      }
    });
  }

  if (button) button.addEventListener('click', handleSubscribe);

  // Enter used to submit the form; with no form there is no implicit
  // submission, so wire it explicitly. preventDefault guards against any
  // ancestor form that might exist in a future layout.
  if (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        handleSubscribe();
      }
    });
  }
});
